import { Link } from 'react-router-dom';
import { categories, allCategory } from '@/mocks/categories';

export default function CategoryGrid() {
  const displayCategories = [allCategory, ...categories];

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            探索出彩分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            无论你擅长什么，这里都有属于你的舞台。选择你感兴趣的领域，发现更多精彩。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center cursor-pointer"
            >
              {cat.slug !== 'all' && (
                <div className="w-full aspect-[4/3] rounded-lg overflow-hidden mb-4">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              )}
              <div className={cat.slug === 'all' ? 'w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors' : ''}>
                {cat.slug === 'all' ? (
                  <i className="ri-apps-line text-primary-600 text-xl md:text-2xl"></i>
                ) : null}
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-3 py-1 rounded-full group-hover:bg-primary-50 group-hover:text-primary-600 transition-colors">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}